import { createEl, clearChildren } from '../dom.js';

/**
 * Строка "Найдено N результатов за X мс" над сеткой результатов.
 * Создаётся один раз на InlinePanel; update(state) вызывается на каждом изменении store.
 */
export class Stats {
    constructor(container) {
        this.el = createEl('div', { className: 'doka-stats' });
        container.appendChild(this.el);
    }

    /**
     * @param {{total: number, tookMs: number}} state
     */
    update({ total, tookMs }) {
        clearChildren(this.el);
        const label = `Найдено ${total.toLocaleString('ru-RU')} ${pluralizeResults(total)} за ${tookMs} мс`;
        this.el.appendChild(document.createTextNode(label));
    }
}

/**
 * Русская плюрализация существительного для "результат".
 * 1 — результат, 2-4 — результата, 0/5-20/и т.д. — результатов.
 */
function pluralizeResults(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 14) return 'результатов';
    if (mod10 === 1) return 'результат';
    if (mod10 >= 2 && mod10 <= 4) return 'результата';
    return 'результатов';
}
